{
  "(optional)": "(valgfritt)",
  "(required)": "(obligatorisk)"
}
